import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Phone, Mail, MapPin, ShieldCheck, ArrowUp } from 'lucide-react';
import { contactInfo, navigationLinks } from '../data';
import Logo from './Logo';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  const handleLinkClick = (e, href) => {
    e.preventDefault();

    if (href.startsWith('/#')) {
      const hash = href.substring(1); // e.g. "#ydelser"
      if (location.pathname !== '/') {
        navigate(href);
      } else {
        const element = document.querySelector(hash);
        if (element) {
          const offset = 80;
          const bodyRect = document.body.getBoundingClientRect().top;
          const elementRect = element.getBoundingClientRect().top;
          const elementPosition = elementRect - bodyRect;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    } else if (href === '/') {
      if (location.pathname !== '/') {
        navigate('/');
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    } else {
      navigate(href);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-slate-50 text-slate-600 pt-16 pb-8 border-t border-slate-200 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 pb-12 border-b border-slate-200">
          
          {/* Brand Column */}
          <div className="lg:col-span-5 space-y-6">
            <a href="#home" onClick={scrollToTop} className="inline-block">
              <Logo className="h-11 sm:h-12" light={false} />
            </a>
          </div>

          {/* Navigation Links Column */}
          <div className="lg:col-span-3 space-y-4">
            <h4 className="text-slate-900 font-bold text-sm uppercase tracking-wider">Hurtige links</h4>
            <ul className="space-y-2.5 text-xs uppercase tracking-wider font-medium">
              {navigationLinks
                .filter((link) => link.label !== 'Ydelser')
                .map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleLinkClick(e, link.href)}
                      className="hover:text-[#0e227b] transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
            </ul>
          </div>

          {/* Contact Info Column */}
          <div className="lg:col-span-4 space-y-4">
            <h4 className="text-slate-900 font-bold text-sm uppercase tracking-wider">Direkte kontakt</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a 
                  href={`tel:${contactInfo.phone}`} 
                  className="flex items-center space-x-3 hover:text-[#0e227b] transition-colors group"
                >
                  <Phone className="w-4 h-4 text-[#0e227b] shrink-0 group-hover:scale-110 transition-transform" />
                  <span>{contactInfo.phone}</span>
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 text-[#0e227b] shrink-0 mt-0.5" />
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Ravn's Vinduespolering. Alle rettigheder forbeholdes.</p>
          <div className="flex space-x-6">
            <span>CVR: {contactInfo.cvr}</span>
            <span>Udviklet i samarbejde med Auxo</span>
          </div>
        </div>

      </div>
    </footer>
  );
}
